import React, {useContext, useEffect} from 'react'
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useAuth} from '@/context/providers/AuthProvider';
import {OrganizationContext} from '@/context/providers/OrganizationProvider';
import {loginFromRedirectHash} from '@/services/auth.service';
import { setAllOrganizations, setCurrentOrganization} from '@/utils/functions/OrganizationFunctions';
import {getEncrypted, setDataInLocalStorage, setFeaturesListInLocalStorage} from '@/utils/functions/helperFunctions';

export const AuthRedirect = () => {
    const { organization, setOrganization } = useContext(OrganizationContext)
    const [queryParams, setQueryParams] = useSearchParams();
    const { id } = useParams()

    const navigate = useNavigate()
    const { saveToken } = useAuth()

    const authenticateByHash = async () => {
        const ssoString = queryParams.get('sso');
        const sso = ssoString === 'true';
        localStorage.removeItem("current_organization")
        
        let response
        try {
            if(sso) {
                localStorage.setItem('loginWithSSO', 'true')
            }
            response = await loginFromRedirectHash(id, sso)
        } catch (e) {
            navigate("/");
            return
        }

        setDataInLocalStorage("name", getEncrypted(response.full_name));
        setDataInLocalStorage("email_address", getEncrypted(response.email_address));
        setDataInLocalStorage("userId", getEncrypted(response.user_id));
        setDataInLocalStorage("sso", sso);

        if(response.access_token || sso) {
            saveToken(response.access_token)
            await setFeaturesListInLocalStorage()
            const organizations = response.organizations
            setAllOrganizations(organizations);

            setCurrentOrganization(response.current_organization);
            // store current organization in context store
            setOrganization(response.current_organization);
            navigate("/")
        } else {
             // store current organization in context store
            setOrganization(response.current_organization);
            setCurrentOrganization(response.current_organization);
            setDataInLocalStorage("session_id", response.session_id);
            if (response.otp_session_token) {
                setDataInLocalStorage("otp_session_token", response.otp_session_token);
                sessionStorage.removeItem("admin_login_password");
            }
            navigate("/otp");
        }

    }

    React.useEffect(() => {
        authenticateByHash()
    }, [])

    return <div/>
}

